<template>
  <div class="media-list">
    <div class="breadcrumb-bar">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/stuList' }"
          >学员管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{this.$route.query.id?"编辑学员":"添加学员"}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main-box">
      <Card style="margin-bottom: 50px">
        <div class="panel-box">
          <h3 class="panel-title">基本信息</h3>
          <div class="panel-content">
            <el-form :inline="true" :model="formStu" label-width="90px">
              <el-form-item label="学员昵称:">
                <el-input
                  v-model="formStu.name"
                  placeholder="昵称为必填项"
                ></el-input>
              </el-form-item>
              <el-form-item label="手机号:" style="margin-left: 300px">
                <el-input
                  v-model="formStu.phone"
                  placeholder="手机号为必填项"
                ></el-input>
              </el-form-item>
              <br />
              <el-form-item label="出生年月:">
                <DatePicker
                  v-model="formStu.birthday"
                  type="date"
                  placeholder="出生年月"
                  format="yyyy-MM-dd"
                  placement="bottom-end"
                ></DatePicker>
              </el-form-item>
              <el-form-item label="性别:" style="margin-left: 300px">
                <el-select v-model="formStu.sex" clearable style="width: 185px">
                  <el-option
                    v-for="item in sexList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <br />
              <el-form-item label="微信号:">
                <el-input
                  v-model="formStu.weixinId"
                  placeholder="请填写微信号"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </Card>
      <Card>
        <div class="panel-box">
          <h3 class="panel-title">报名信息</h3>
          <div class="panel-content">
            <el-form :inline="true" :model="formStu" label-width="100px">
              <el-form-item label="定级老师:">
                <teacherSelect
                  @teacherResult="teacherChgHandle"
                  :mainTeacherName="formStu.rateTeacher"
                  >选择定级老师</teacherSelect
                >
              </el-form-item>
              <!-- <el-form-item label="拉群续费:">
                <teacherSelect
                  @teacherResult="teacherChgHandle1"
                  :mainTeacherName="formStu.renewalTeacher"
                
                  >选择拉群续费老师</teacherSelect
                >  
              </el-form-item> -->
              <!-- <br /> -->
              <el-form-item label="报名时间:">
                <DatePicker
                  v-model="formStu.signupDate"
                  type="date"
                  format="yyyy-MM-dd"
                  placement="bottom-end"
                  :clearable="false"
                ></DatePicker>
              </el-form-item>
              <el-form-item label="会员有效期:" v-if="zxstatus != 4" style="width：20px;">
                <div v-if="currId == ''">
                  <DatePicker
                    v-model="formStu.expireDate"
                    :options="endOptions"
                    type="date"
                    :placeholder="expireShow"
                    format="yyyy-MM-dd"
                    placement="bottom-end"
                  ></DatePicker>
                </div>
                <div v-else class="btnFlex">
                  <span>{{
                    formStu.expireDate ? formStu.expireDate : "永久有效"
                  }}</span>
                  <!-- :signupDate="formStu.signupDate" -->
                  <stuChgExpire
                    @chgExpire="chgExpireHandle"
                    :bmTime="formStu.bmTime"
                    btnSize="mini"
                    style="margin-left: 5px"
                    >编辑</stuChgExpire
                  >
                </div>
              </el-form-item>
              <el-form-item label="">
                <div class="btnFlex">
                  <stuAddClass @classResult="classChgHandle">分班</stuAddClass>
                  <!-- <span
                    style="color: green; margin-left: 10px"
                    v-if="allocatClassId"
                    >班级ID：{{ allocatClassId }}
                  </span>
                  <span
                    v-if="allocatTeaClass"
                    style="color: green; margin-left: 10px"
                    >老师：{{ allocatTeaClass }}</span
                  > -->
                  <span v-if="allClass.length" style="color: green; margin-left: 10px"
                    >班级ID：</span>
                  <template v-if="allClass.length">
                    <span v-for="item in allClass"
                      style="color: green; margin-left: 10px"
                      >{{ item.classId }}
                    </span>
                  </template>
                  <span v-if="allocatTeaClass.length" style="color: green; margin-left: 10px"
                    >老师：</span>
                  <template v-if="allocatTeaClass.length">
                    <span v-for="item in allocatTeaClass"
                      style="color: green; margin-left: 10px"
                      >{{ item }}
                    </span>
                  </template>
                </div>
              </el-form-item>
              <br />
              <el-form-item label="备注:">
                <el-input
                  :rows="5"
                  style="width: 800px"
                  v-model="formStu.remark"
                  type="textarea"
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </Card>
      <el-button
        type="primary"
        style="margin-left: 45%; margin-top: 30px; margin-bottom: 50px"
        @click="confirmSubmit"
        >完成</el-button
      >
      <el-button @click="cancelEdit">取消</el-button>
    </div>
  </div>
</template>

<script>
import { ApiMessage } from "@/utils/util";
import { formatDateString, testPhone, nowDateToNowStr } from "../commonEdu";
import stuAddClass from "../componentsEdu/stuAddClass2";
import teacherSelect from "../componentsEdu/teacherSelect";
import stuChgExpire from "../componentsEdu/stuChgExpire";
export default {
  name: "addStu",
  components: { stuAddClass, stuChgExpire, teacherSelect },
  data() {
    return {
      formStu: {
        name: "",
        phone: "",
        birthday: "",
        sex: null,
        signupDate: "",
        bmTime: "",
        expireDate: "",
        expireTag: "",
        remark: "",
        weixinId: "", //微信号
        rateTeacher: "",
        renewalTeacher: ""
      },
      sexList: [
        {
          value: 1,
          label: "男",
        },
        {
          value: 2,
          label: "女",
        },
      ],
      currId: "",
      endOptions: {
        shortcuts: [
          {
            text: "永久有效",
            value() {
              //return "2121-01-01";
              return "";
            },
          },
        ],
      },
      allocatClassId: "",
      // allocatTeaClass: "", //班级老师
      allocatTeaClass: [], //班级老师
      allClass:[],
      oldAllClass:[],
      expireShow: "永久有效",
      zxstatus: "",
      defaultBirthday: "",
      teacherName: "", //老师名称
      teacherName1: "", //老师名称
      rateTeacherId: "", //定级老师ID
      renewalTeacherId: "", //拉群续费老师ID
    };
  },
  created() {

    this.defaultBirthday = new Date("2014/01/01");
    this.formStu.birthday = this.defaultBirthday;
    this.fetchDetail();
    this.zxstatus = this.$route.query.status;
  },
  watch: {},
  methods: {
    fetchDetail() {
      if (this.$route.query.id != undefined) {
        this.currId = `${this.$route.query.id}`;
        let params = {
          appId: this.$API.APPID,
          id: this.currId,
        };
        this.eduAxiosPostRequest("/edu/eduAdmin/stu/detail", params).then(
          (res) => {
            if (res != null) {
              let m = JSON.parse(res);
              this.formStu.name = m.name;
              this.formStu.phone = m.phone;
              this.formStu.remark = m.remark;
              this.formStu.expireTag = m.expireTag;
              this.formStu.bmTime = m.signupDate;
              this.formStu.weixinId = m.weixinId;
              this.formStu.rateTeacher = m.rateTeacher; //定级老师id
              this.formStu.renewalTeacher = m.renewalTeacher;
              this.rateTeacherId = m.rateTeacherId
              this.renewalTeacherId = m.renewalTeacherId
              if (m.sex != 0) {
                this.formStu.sex = m.sex;
              }
              if (m.signupDate) {
                this.formStu.signupDate = m.signupDate; //报名时间
              }
              if (m.expireDate == undefined) {
                this.formStu.expireDate = "";
              } else {
                if (m.expireDate == "2121-01-01") {
                  this.formStu.expireDate = "";
                } else {
                  this.formStu.expireDate = m.expireDate;
                }
              }
              if (m.birthday != null) {
                this.formStu.birthday = m.birthday;
              } else {
                this.formStu.birthday = this.defaultBirthday;
              }
              if(m.classList&&m.classList.length){
                this.allClass=[]
                this.oldAllClass=[]
                this.allocatTeaClass=[]
                m.classList.forEach(addItem=>{
                  this.allClass.push({
                    classId:String(addItem.classId),
                    groupId:addItem.groupId?String(addItem.groupId):'0'
                  })
                  this.oldAllClass.push(String(addItem.classId))
                  if(addItem.mainTeacher&&addItem.mainTeacher.teacherName){
                    this.allocatTeaClass.push(addItem.mainTeacher.teacherName)
                  }
                })
              }
              console.log(this.formStu.signupDate);
            }
          }
        );
      } else {
        this.formStu.birthday = this.defaultBirthday;
        this.formStu.signupDate = nowDateToNowStr();
      }
    },
    confirmSubmit() {
      if (this.formStu.name == "") {
        alert("学员昵称不能为空");
        return;
      } else if (this.formStu.phone == "") {
        alert("电话号码不能为空");
        return;
      } else if (this.formStu.birthday == "") {
        alert("生日不能为空");
        return;
      } 
      else if (!testPhone(this.formStu.phone)) {
        alert("电话号码格式不正确");
        return;
      }
      let params = {
        appId: this.$API.APPID,
        name: this.formStu.name,
        phone: this.formStu.phone,
        signupDate: formatDateString(this.formStu.signupDate),
        birthday: formatDateString(this.formStu.birthday),
        remark: this.formStu.remark,
        weixinId: this.formStu.weixinId,
        rateTeacherId: this.rateTeacherId || 0,
        renewalTeacherId: this.renewalTeacherId || 0,
        confirmSave:1
      };
      if (this.formStu.sex != null) {
        params.sex = this.formStu.sex;
      }
      if (this.currId != "") {
        params.id = this.currId;
      }
      if (this.allocatClassId != "") {
        params.classId = this.allocatClassId.toString();
      }
      if(this.allClass.length){
        let paramClassId=[]
        this.allClass.forEach(itemB => {
          const isExisted = this.oldAllClass.some(itemA => itemA == String(itemB.classId));
          if (!isExisted) {
            paramClassId.push(itemB);
          }
        });
        params.classIds = paramClassId;
      }
      if (this.formStu.expireDate != "") {
        params.expireDate = formatDateString(this.formStu.expireDate);
      } else {
        params.expireDate = "2121-01-01";
      }
      this.eduAxiosPostRequest("/edu/eduAdmin/stu/save", params).then((res) => {
        if (res != null) {
          this.$Message.success("操作成功!");
          this.cancelEdit();
        }
      });
    },
    cancelEdit() {
      this.$router.push({
        name: "stulist",
      });
    },
    classChgHandle(clsArr) {
      console.log(clsArr)
      clsArr.forEach(itemB => {
        // some()：只要有一个元素满足条件就返回true，否则false
        const isExisted = this.allClass.some(itemA => String(itemA.classId) == itemB.classId);
        if (!isExisted) {
          this.allClass.push({
            classId:String(itemB.classId),
            groupId:itemB.group_id?String(itemB.group_id):'0'
          });
          this.allocatTeaClass.push(itemB.mainTeacher&&itemB.mainTeacher.teacherName?itemB.mainTeacher.teacherName:'')
        }
      });

      // this.allocatClassId = clsArr.classId;
      // this.allocatTeaClass = clsArr.mainTeacher.name;
    },
    teacherChgHandle(teaArr) {
    
      this.teacherName = teaArr.name;
      this.rateTeacherId = teaArr.id;
    },
    teacherChgHandle1(teaArr) {
      console.log(teaArr, "89778888899");
      this.teacherName1 = teaArr.name;
      this.renewalTeacherId = teaArr.id;
    },
    chgExpireHandle(val, selectValue, signupDate, bmTime) {
      let stuIds = [];
      stuIds.push(`${this.$route.query.id}`);
      if (val == "") {
        alert("请选择有效期");
        return;
      } else if (selectValue == "" || selectValue == "请选择操作类型") {
        alert("请选择操作类型");
        return;
      }
      else {
        let params = {
          appId: this.$API.APPID,
          ids: stuIds,
          expireDate: val,
          expireOper: Number(selectValue),
        };

        this.$axios
          .post("/edu/eduAdmin/stu/batch_save", params)
          .then((response) => {
            console.log(response, "eee");
            if (response.data.rc == "0") {
              this.$Message.success("操作成功!");
              this.fetchDetail();
            } else if (response.data.rc == "-8") {
              alert("已在会员有效期内，不需要续费哦！");
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          });
      }
    },
    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            // console.log(response);
            if (response.data.rc == "0") {
              resolve(JSON.stringify(response.data.data));
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>

<style lang="less">
@import "../fyd-style";
@import "../commonEdu";
.btnFlex{
  flex-wrap: wrap;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// addStu.vue?64a187d4